import PropTypes from 'prop-types';
import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import styles from './SpinnerWrapper.scss';

const SpinnerWrapper = ({ meaning = 'Loading...', meaningVisible = false, ...rest }) => {
  const { size, color = 'dark' } = rest;
  const className = [
    styles['spinner-wrapper'],
    !!size && size.toLowerCase().trim() === 'sm' ? ` ${styles['sm']}` : '',
    color === 'dark' ? styles['dark'] : styles['light'],
  ].join(' ');

  return meaningVisible ? (
    <div className={styles['spinner-wrapper-container']}>
      <Spinner {...rest} animation="border" className={className} role="status" />
      {meaning}
    </div>
  ) : (
    <Spinner {...rest} animation="border" className={className} role="status">
      <span className="visually-hidden">{meaning}</span>
    </Spinner>
  );
};

SpinnerWrapper.propTypes = {
  meaning: PropTypes.string,
  meaningVisible: PropTypes.bool,
  color: PropTypes.oneOf(['dark', 'light']),
};

export default SpinnerWrapper;
